import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import store from './state-store/store';
import App from './App/App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js